import { Base } from './base';

export default class ShareServiceDetail extends Base {
	constructor () {
		super()
	}

	async detailData( id ) {
		const res = await this.shares_detail( id )

		return {
			...res.posts
		}
	}

	async videoDetailData( id ) {
		const res = await this.shares_video_detail( id )
		const { list } = res.posts

		return list
	}
}
